import { useEffect } from "react";
import { motion, isValidMotionProp, useWillChange } from "framer-motion";

import { useNavigate } from "react-router";
import { usePreviousPagePath } from "../../hook/usePreviousPagePath";
import { useTranslation } from "react-i18next";
import { Box, chakra, shouldForwardProp } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import SignupForm from "./signupForm";
import useCheckLogin from "../../hook/useCheckLogin";
import { resetInvalidAuth } from "../../redux/action/member/memberAction";
import { useDispatch } from "react-redux";
import { COMMON_WEB_PATH } from "../../constant";
import CommonModal from "../../components/Common/CommonModal";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const Signup = () => {
  const { t } = useTranslation();
  const i18n_header = (key) => t(`header.${key}`);
  const i18n_backend_response = (key) => t(`backend_response.${key}`);

  const navigate = useNavigate();
  const previousPage = usePreviousPagePath();

  const dispatch = useDispatch();

  const willChange = useWillChange();

  const { isLogin } = useCheckLogin();

  useEffect(() => {
    dispatch(resetInvalidAuth());

    if (isLogin) {
      navigate("/");
    }
  }, []);

  return (
    <ChakraBox
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      style={{ willChange }}
      display="flex"
      flexDirection={`column`}
      justifyContent={`start`}
      alignItems="center"
      zIndex="10000"
      py="10vh"
      px="10px"
      width={{
        base: "100%",
      }}
      height={{
        base: "100%",
      }}
      overflowY={`scroll`}
      position="fixed"
      top={`0px`}
      left={`0px`}
      className={`lg:backdrop-blur-none backdrop-blur-md no-scrollbar`}
    >
      <CommonModal bgNone title={i18n_header("signup")}>
        {/* 隱形XX */}
        <Box
          as={Link}
          to={previousPage}
          position="absolute"
          top="-40px"
          right="0px"
          w="30px"
          h="30px"
          bgImage={`url('${COMMON_WEB_PATH}/theOne/modal/close_icon.png')`}
          bgSize="100% 100%"
          bgPos="center"
          cursor="pointer"
        ></Box>
        <Box px="common-x">
          <Box
            width="100%"
            px="common-x"
            py="10px"
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            className="no-scrollbar"
          >
            <SignupForm />
          </Box>
        </Box>
      </CommonModal>
    </ChakraBox>
  );
};

export default Signup;
